import React from 'react';
import { useHomeStrings } from '../../hooks/useHomeStrings';
import type { HomeBusinessStatus } from '../../model/types';

interface Props {
  status: HomeBusinessStatus;
}

export const StatusBadge: React.FC<Props> = ({ status }) => {
  const STRINGS = useHomeStrings();
  const isOpen = status === 'OPEN';
  return (
    <span
      role="status"
      aria-label={isOpen ? STRINGS.STATUS_OPEN : STRINGS.STATUS_CLOSED}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        borderRadius: 20,
        padding: '4px 10px',
        fontSize: 12,
        fontWeight: 600,
        flexShrink: 0,
        background: isOpen ? 'rgba(255,255,255,0.20)' : 'rgba(255,255,255,0.15)',
        color: isOpen ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.7)',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: isOpen ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.5)',
          flexShrink: 0,
          display: 'inline-block',
        }}
      />
      {isOpen ? STRINGS.STATUS_OPEN : STRINGS.STATUS_CLOSED}
    </span>
  );
};
